module.exports = __webpack_public_path__ + "img/placeholder-shutup.972b8390.png";